<template>
  <section class="vh-100 gradient-custom">
    <div class="container py-5 h-100">
      <div class="row d-flex justify-content-center align-items-center h-100">
        <div class="col-12 col-md-8 col-lg-6 col-xl-5">
          <div class="card">
            <div class="card-body">
              <div class="mb-md-5 mt-md-3">
                <div class="login-header">
                  <img src="../assets/golfnow.png" width="100%" />
                  <p class="text-black-50 mb-5">
                    Enter your GolfNow Premier Tee Sheet credentials
                  </p>
                </div>

                <div class="form-outline form-white mb-4 row">
                  <label
                    class="form-label col-sm-3 col-form-label"
                    for="typeEmailX"
                    >Username</label
                  >
                  <div class="col-sm-9">
                    <input
                      type="email"
                      id="typeEmailX"
                      class="form-control form-control-lg"
                      v-model="credentials.email"
                    />
                  </div>
                </div>

                <div class="form-outline form-white mb-4 row">
                  <label
                    class="form-label col-sm-3 col-form-label"
                    for="typePasswordX"
                    >Password</label
                  >
                  <div class="col-sm-9">
                    <input
                      type="password"
                      id="typePasswordX"
                      class="form-control form-control-lg"
                      v-model="credentials.password"
                      v-on:keyup.enter="onEnter"
                    />
                  </div>
                </div>

                <div
                  v-if="errorMessage"
                  class="alert alert-danger"
                  role="alert"
                >
                  {{ errorMessage }}
                </div>

                <button
                  class="btn btn-lg btn-primary"
                  type="submit"
                  :disabled="isLoading"
                  @click="login"
                >
                  Login
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script lang="ts">
import { loadingService } from '@/services/loading-service';
import { defineComponent, ref } from 'vue';
import { useRouter } from 'vue-router';
import { UserApi, Configuration } from '../api';

export default defineComponent({
  name: 'LoginForm',
  setup() {
    const credentials = ref({ email: '', password: '' });
    const errorMessage = ref('');
    const isLoading = ref(false);
    const router = useRouter();
    const baseUrl = process.env.VUE_APP_BASE_URL;

    if (!baseUrl) {
      throw new Error(
        'VUE_APP_BASE_URL environment variable is not set. Please configure the environment variable for this build.'
      );
    }
    const config = new Configuration({
      basePath: baseUrl,
    });
    const api = new UserApi(config);

    async function login() {
      // Clear any previous error message
      errorMessage.value = '';

      const { email, password } = credentials.value;

      // Validate the form
      if (!email && !password) {
        errorMessage.value = 'Please enter your Username and Password.';
        return;
      } else if (!email) {
        errorMessage.value = 'Please enter your Username.';
        return;
      } else if (!password) {
        errorMessage.value = 'Please enter your Password.';
        return;
      }

      try {
        isLoading.value = true;
        loadingService.startLoading();
        const response = await api.loginPost({
          username: email,
          password: password,
        });
        const jwt = (response as any).data.token;
        localStorage.setItem('jwt', jwt);
        // Redirect to the main layout
        router.push({ name: 'MainLayout' });
      } catch (error) {
        console.error('Login failed', error);
        errorMessage.value =
          'Login failed. Please check your credentials and try again.';
      } finally {
        isLoading.value = false;
        loadingService.stopLoading();
      }
    }

    async function onEnter() {
      login();
    }

    return { credentials, isLoading, errorMessage, login, onEnter };
  },
});
</script>

<style>
.gradient-custom {
  background: linear-gradient(45deg, #6e8efb, #88ceb2);
  background-image: url('../assets/background.jpg');
  background-size: cover;
  background-position: bottom;
}

.btn-primary {
  background-color: #46991e;
  border-color: #59a72c;
}

.btn-primary:hover {
  background-color: #9fd27b;
  border-color: #59a72c;
}

.alert {
  margin-top: 1rem;
}
</style>
